<template>
  <fragment>
    <Label
      v-bind="labelProps"
      :html-for="id"
      :bold="labelBold"
      v-if="label"
      :disabled="disabled"
    >
      {{label}}
    </Label>
    <v-swatches
      class="input-color"
      :swatches="colors"
      shapes="circles"
      @input="updateValue"
    />
  </fragment>
</template>

<script>
import VSwatches from 'vue-swatches';
import Label from './Label';

export default {
  name: 'InputColor',
  components: {
    Label,
    VSwatches,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {},
    label: {
      type: String,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    labelProps: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    colors: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
